var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5868_34112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.26409 7.74961L3.51409 6.70039C3.08006 6.58086 2.77798 6.19238 2.77798 5.76074C2.77798 5.21953 3.23631 4.78125 3.80228 4.78125H6.10437C6.52798 4.78125 6.94464 4.9041 7.29187 5.12988C7.50367 5.26602 7.78839 5.23281 7.96895 5.06348L9.17728 3.93457C9.42381 3.70547 9.38909 3.32363 9.11478 3.12109C8.26409 2.48359 7.20159 2.12832 6.11131 2.125V0.53125C6.11131 0.239062 5.86131 0 5.55576 0H4.44464C4.13909 0 3.88909 0.239062 3.88909 0.53125V2.125H3.80228C1.59048 2.125 -0.1873 3.94121 0.017561 6.09609C0.163394 7.62676 1.38562 8.87188 2.92728 9.30352L6.48631 10.2996C6.92034 10.4225 7.22242 10.8076 7.22242 11.2393C7.22242 11.7805 6.76409 12.2188 6.19812 12.2188H3.89603C3.47242 12.2188 3.05576 12.0959 2.70853 11.8701C2.49673 11.734 2.21201 11.7672 2.03145 11.9365L0.823117 13.0654C0.576589 13.2945 0.611311 13.6764 0.885617 13.8789C1.73631 14.5164 2.79881 14.8717 3.88909 14.875V16.4688C3.88909 16.7609 4.13909 17 4.44464 17H5.55576C5.86131 17 6.11131 16.7609 6.11131 16.4688V14.8684C7.72937 14.8385 9.24673 13.9187 9.78145 12.4545C10.528 10.4092 9.27451 8.31074 7.26409 7.74961Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5868_34112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountingIcon);
export default __webpack_public_path__ + "static/media/accounting_icon.cd94abc8653b7deebf235891aa1e99b4.svg";
export { ForwardRef as ReactComponent };